import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-layout',
  styleUrls: ['./app-footer-layout.component.scss'],
  imports: [TranslateModule, RouterModule],
  templateUrl: './app-footer-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFooterLayoutComponent {}
